import { useState, useRef } from "react";

import Header from '../Component/Header';
import Footer from '../Component/Footer';
import ExperienceTripslist from "../Components/ExperienceTripslist";
import ExperienceLocalexpertlist from "../Components/ExperienceLocalexpertlist";
import { API_BASE } from "../api/apiConfig";

const ExperienceTrips = () => {
   const scrollRef = useRef(null);

  const scrollLeftFn = () => {
    scrollRef.current.scrollBy({
      left: -300,
      behavior: "smooth",
    });
  };

  const scrollRightFn = () => {
    scrollRef.current.scrollBy({
      left: 300,
      behavior: "smooth",
    });
  };



  const [activeModal, setActiveModal] = useState(null);

  return (
    <>
      <Header />

<main className="flex-1">
  {/*$*/}
  <div className="min-h-screen bg-white">
    <section className="relative md:hidden">
      <div className="relative h-[280px] w-full">
        <img
          src="/assets/images/group-travel-adventure-mountains.jpg"
          alt="Travelers on an experience trip"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-5">
          <p className="text-white/70 text-xs font-medium tracking-wide uppercase mb-2">
            Experience Trips
          </p>
          <h1 className="text-xl font-bold text-white leading-tight mb-2">
            Travel That Builds Your Future
          </h1>
          <p className="text-white/80 text-sm leading-relaxed">
            Travel with purpose. Learn new skills, expand your network, and
            return home smarter.
          </p>
        </div>
      </div>
    </section>
    <section className="relative hidden md:block py-14">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="relative order-2 lg:order-1">
            <div className="relative aspect-[4/3] rounded-3xl overflow-hidden bg-slate-100">
              <img
                src="/assets/images/group-travel-adventure-mountains.jpg"
                alt="Travelers on an experience trip"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-6 left-6 max-w-[300px] bg-white/95 backdrop-blur-sm rounded-2xl p-4 shadow-lg">
                <div className="flex items-center gap-3 mb-3">
                  <div className="flex -space-x-2">
                    <div className="relative h-8 w-8 rounded-full overflow-hidden border-2 border-white">
                      <img
                        alt=""
                        loading="lazy"
                        decoding="async"
                        data-nimg="fill"
                        className="object-cover"
                        style={{
                          position: "absolute",
                          height: "100%",
                          width: "100%",
                          left: 0,
                          top: 0,
                          right: 0,
                          bottom: 0,
                          color: "transparent"
                        }}
                        src="/assets/images/member-1.png"
                      />
                    </div>
                    <div className="relative h-8 w-8 rounded-full overflow-hidden border-2 border-white">
                      <img
                        alt=""
                        loading="lazy"
                        decoding="async"
                        data-nimg="fill"
                        className="object-cover"
                        style={{
                          position: "absolute",
                          height: "100%",
                          width: "100%",
                          inset: 0
                        }}
                        src="/assets/images/member-3.jpg"
                      />
                    </div>
                    <div className="relative h-8 w-8 rounded-full overflow-hidden border-2 border-white">
                      <img
                        alt=""
                        loading="lazy"
                        decoding="async"
                        data-nimg="fill"
                        className="object-cover"
                        style={{
                          position: "absolute",
                          height: "100%",
                          width: "100%",
                          left: 0,
                          top: 0,
                          right: 0,
                          bottom: 0,
                          color: "transparent"
                        }}
                        src="/assets/images/member-1.png"
                      />
                    </div>
                  </div>
                  <span className="text-sm text-slate-600">
                    Learn from 20+ Experts
                  </span>
                </div>
                <p className="text-xs text-slate-500">
                  Travel with photographers, chefs, artists &amp; storytellers
                  who inspire and teach.
                </p>
              </div>
            </div>
          </div>
          <div className="order-1 lg:order-2">
            <div className="inline-flex items-center gap-2 bg-primary/10 text-primary text-sm font-medium px-3 py-1.5 rounded-full mb-4">
              <span className="w-1.5 h-1.5 bg-primary rounded-full" />
              Experience Trips
            </div>
            <h1 className="text-4xl lg:text-5xl font-bold leading-tight mb-4">
              <span className="text-primary">Travel That Builds</span>
              <br />
              <span className="text-slate-900">Your Future</span>
            </h1>
            <p className="text-base lg:text-lg text-slate-600 leading-relaxed mb-6">
              Travel with purpose. Learn new skills, expand your network, and
              return home smarter.
            </p>
            <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-slate-500">
              <span className="flex items-center gap-2">
                <span className="w-1 h-1 bg-slate-400 rounded-full" />
                Learn new skills
              </span>
              <span className="flex items-center gap-2">
                <span className="w-1 h-1 bg-slate-400 rounded-full" />
                Connect with experts
              </span>
              <span className="flex items-center gap-2">
                <span className="w-1 h-1 bg-slate-400 rounded-full" />
                Small groups of 8-16
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="md:hidden bg-slate-50 py-5">
      <div className="px-4">
        <p className="text-xs font-medium text-slate-500 uppercase tracking-wider mb-3">
          Discover More
        </p>
        <div className="grid grid-cols-2 gap-2">
          <button
            type="button" onClick={() => setActiveModal("how")}
            className="flex items-center gap-2 px-3 py-2.5 rounded-xl text-xs font-medium transition-all bg-white text-slate-700 border border-slate-200 hover:border-slate-300 active:scale-95"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-search h-4 w-4 flex-shrink-0 text-slate-500"
            >
              <circle cx={11} cy={11} r={8} />
              <path d="m21 21-4.3-4.3" />
            </svg>
            <span className="truncate">How It Works</span>
          </button>
          <button
            type="button" onClick={() => setActiveModal("who")}
            className="flex items-center gap-2 px-3 py-2.5 rounded-xl text-xs font-medium transition-all bg-white text-slate-700 border border-slate-200 hover:border-slate-300 active:scale-95"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-target h-4 w-4 flex-shrink-0 text-slate-500"
            >
              <circle cx={12} cy={12} r={10} />
              <circle cx={12} cy={12} r={6} />
              <circle cx={12} cy={12} r={2} />
            </svg>
            <span className="truncate">Who Is This For</span>
          </button>
          <button
            type="button" onClick={() => setActiveModal("learn")}
            className="flex items-center gap-2 px-3 py-2.5 rounded-xl text-xs font-medium transition-all bg-white text-slate-700 border border-slate-200 hover:border-slate-300 active:scale-95"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-lightbulb h-4 w-4 flex-shrink-0 text-slate-500"
            >
              <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
              <path d="M9 18h6" />
              <path d="M10 22h4" />
            </svg>
            <span className="truncate">What You'll Learn</span>
          </button>
          <button
            type="button" onClick={() => setActiveModal("meet")}
            className="flex items-center gap-2 px-3 py-2.5 rounded-xl text-xs font-medium transition-all bg-white text-slate-700 border border-slate-200 hover:border-slate-300 active:scale-95"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-users h-4 w-4 flex-shrink-0 text-slate-500"
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx={9} cy={7} r={4} />
              <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
            <span className="truncate">Who You'll Meet</span>
          </button>
          <button
            type="button" onClick={() => setActiveModal("different")}
            className="flex items-center gap-2 px-3 py-2.5 rounded-xl text-xs font-medium transition-all bg-white text-slate-700 border border-slate-200 hover:border-slate-300 active:scale-95"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-globe h-4 w-4 flex-shrink-0 text-slate-500"
            >
              <circle cx={12} cy={12} r={10} />
              <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
              <path d="M2 12h20" />
            </svg>
            <span className="truncate">What's Different</span>
          </button>
          <button
            type="button" onClick={() => setActiveModal("take")}
            className="flex items-center gap-2 px-3 py-2.5 rounded-xl text-xs font-medium transition-all bg-white text-slate-700 border border-slate-200 hover:border-slate-300 active:scale-95"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-rocket h-4 w-4 flex-shrink-0 text-slate-500"
            >
              <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
              <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
              <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" />
              <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
            </svg>
            <span className="truncate">What You Take Home</span>
          </button>
        </div>
      </div>
    </section>
    <section className="hidden md:block bg-slate-50 py-10">
      <div className="container mx-auto px-6">
        <div className="text-center mb-8">
          <p className="text-sm font-medium text-slate-500 uppercase tracking-wider mb-2">
            Everything You Need To Know
          </p>
          <h2 className="text-2xl lg:text-3xl font-bold text-slate-900">
            Click to explore
          </h2>
        </div>
        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          <button
            type="button" onClick={() => setActiveModal("how")}
            className="group flex items-center gap-2.5 px-5 py-3 rounded-2xl text-sm font-medium transition-all duration-200 bg-white text-slate-700 border border-slate-200 hover:border-slate-300 hover:shadow-md"
          >
            <div className="h-9 w-9 rounded-xl bg-slate-100 flex items-center justify-center group-hover:bg-slate-200 transition-colors">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-search h-5 w-5 text-slate-600"
              >
                <circle cx={11} cy={11} r={8} />
                <path d="m21 21-4.3-4.3" />
              </svg>
            </div>
            How It Works
          </button>
          <button
            type="button" onClick={() => setActiveModal("who")}
            className="group flex items-center gap-2.5 px-5 py-3 rounded-2xl text-sm font-medium transition-all duration-200 bg-white text-slate-700 border border-slate-200 hover:border-slate-300 hover:shadow-md"
          >
            <div className="h-9 w-9 rounded-xl bg-slate-100 flex items-center justify-center group-hover:bg-slate-200 transition-colors">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-target h-5 w-5 text-slate-600"
              >
                <circle cx={12} cy={12} r={10} />
                <circle cx={12} cy={12} r={6} />
                <circle cx={12} cy={12} r={2} />
              </svg>
            </div>
            Who Is This For
          </button>
          <button
            type="button" onClick={() => setActiveModal("learn")}
            className="group flex items-center gap-2.5 px-5 py-3 rounded-2xl text-sm font-medium transition-all duration-200 bg-white text-slate-700 border border-slate-200 hover:border-slate-300 hover:shadow-md"
          >
            <div className="h-9 w-9 rounded-xl bg-slate-100 flex items-center justify-center group-hover:bg-slate-200 transition-colors">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-lightbulb h-5 w-5 text-slate-600"
              >
                <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
                <path d="M9 18h6" />
                <path d="M10 22h4" />
              </svg>
            </div>
            What You'll Learn
          </button>
          <button
            type="button" onClick={() => setActiveModal("meet")}
            className="group flex items-center gap-2.5 px-5 py-3 rounded-2xl text-sm font-medium transition-all duration-200 bg-white text-slate-700 border border-slate-200 hover:border-slate-300 hover:shadow-md"
          >
            <div className="h-9 w-9 rounded-xl bg-slate-100 flex items-center justify-center group-hover:bg-slate-200 transition-colors">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-users h-5 w-5 text-slate-600"
              >
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx={9} cy={7} r={4} />
                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
            </div>
            Who You'll Meet
          </button>
          <button
            type="button" onClick={() => setActiveModal("different")}
            className="group flex items-center gap-2.5 px-5 py-3 rounded-2xl text-sm font-medium transition-all duration-200 bg-white text-slate-700 border border-slate-200 hover:border-slate-300 hover:shadow-md"
          >
            <div className="h-9 w-9 rounded-xl bg-slate-100 flex items-center justify-center group-hover:bg-slate-200 transition-colors">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-globe h-5 w-5 text-slate-600"
              >
                <circle cx={12} cy={12} r={10} />
                <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
                <path d="M2 12h20" />
              </svg>
            </div>
            What's Different
          </button>
          <button
            type="button" onClick={() => setActiveModal("take")}
            className="group flex items-center gap-2.5 px-5 py-3 rounded-2xl text-sm font-medium transition-all duration-200 bg-white text-slate-700 border border-slate-200 hover:border-slate-300 hover:shadow-md"
          >
            <div className="h-9 w-9 rounded-xl bg-slate-100 flex items-center justify-center group-hover:bg-slate-200 transition-colors">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-rocket h-5 w-5 text-slate-600"
              >
                <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
                <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
                <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" />
                <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
              </svg>
            </div>
            What You Take Home
          </button>
        </div>
      </div>
    </section>
    

    <ExperienceTripslist />


    <section className="py-10 md:py-20 lg:py-28">
      <div className="container mx-auto px-4 md:px-6">
        <div className="hidden lg:grid lg:grid-cols-3 gap-12 items-center max-w-6xl mx-auto">
          <div className="text-center">
            <h3 className="text-3xl xl:text-4xl font-bold text-slate-900 leading-tight mb-4">
              Expert-led
              <br />
              journeys.
            </h3>
            <p className="text-slate-600 leading-relaxed">
              Each trip is hosted by a verified Travel Expert with deep local
              knowledge, ensuring authentic immersion.
            </p>
          </div>
          <div className="relative">
            <div className="relative h-[400px] w-full rounded-3xl overflow-hidden">
              <img
                alt="Travelers on an experience trip"
                loading="lazy"
                decoding="async"
                data-nimg="fill"
                className="object-cover"
                style={{
                  position: "absolute",
                  height: "100%",
                  width: "100%",
                  left: 0,
                  top: 0,
                  right: 0,
                  bottom: 0,
                  color: "transparent"
                }}
                src="/assets/images/community-gathering.png"
              />
            </div>
          </div>
          <div className="text-center">
            <h3 className="text-3xl xl:text-4xl font-bold text-slate-900 leading-tight mb-4">
              Small group
              <br />
              adventures.
            </h3>
            <p className="text-slate-600 leading-relaxed">
              Travel with 8-16 like-minded explorers in intimate settings,
              forging connections that last beyond the trip.
            </p>
          </div>
        </div>
        <div className="lg:hidden space-y-5 md:space-y-8">
          <div className="relative h-[180px] sm:h-[220px] md:h-[280px] w-full rounded-2xl md:rounded-3xl overflow-hidden">
            <img
              alt="Travelers on an experience trip"
              loading="lazy"
              decoding="async"
              data-nimg="fill"
              className="object-cover"
              style={{
                position: "absolute",
                height: "100%",
                width: "100%",
                left: 0,
                top: 0,
                right: 0,
                bottom: 0,
                color: "transparent"
              }}
              src="/assets/images/community-gathering.png"
            />
          </div>
          <div className="grid grid-cols-2 gap-4 md:gap-8">
            <div className="text-center">
              <h3 className="text-base md:text-2xl font-bold text-slate-900 leading-tight mb-2 md:mb-3">
                Expert-led journeys.
              </h3>
              <p className="text-slate-600 text-xs md:text-sm leading-relaxed">
                Each trip is hosted by a verified Travel Expert with deep local
                knowledge.
              </p>
            </div>
            <div className="text-center">
              <h3 className="text-base md:text-2xl font-bold text-slate-900 leading-tight mb-2 md:mb-3">
                Small group adventures.
              </h3>
              <p className="text-slate-600 text-xs md:text-sm leading-relaxed">
                Travel with 8-16 like-minded explorers in intimate settings.
              </p>
            </div>
          </div>
        </div>
        <div className="mt-8 md:mt-16 max-w-2xl mx-auto">
          <div className="bg-primary/5 rounded-xl md:rounded-2xl p-5 md:p-8 text-center">
            <h4 className="text-base md:text-xl font-bold text-slate-900 mb-2 md:mb-3">
              Our Philosophy
            </h4>
            <p className="text-slate-600 text-xs md:text-base leading-relaxed">
              We believe travel should transform you. That's why we partner with
              passionate local experts who don't just show you places—they share
              their world with you.
            </p>
          </div>
        </div>
      </div>
    </section>
    

    <ExperienceLocalexpertlist />

    
  </div>
  {/*/$*/}
</main>








{activeModal === "how" && (
  <div className="fixed inset-0 z-[100] flex items-end md:items-center justify-center bg-black/50 backdrop-blur-sm">

    {/* ================= MOBILE BOTTOM SHEET ================= */}
    <div className="md:hidden bg-white rounded-t-2xl w-full max-h-[85vh] overflow-hidden shadow-2xl animate-in slide-in-from-bottom duration-300">

      <div className="flex justify-center pt-3 pb-2">
        <div className="w-10 h-1 bg-slate-300 rounded-full" />
      </div>

      <div className="bg-slate-900 px-5 py-4 relative mx-4 rounded-xl">
        <button
          onClick={() => setActiveModal(null)}
          className="absolute top-3 right-3 h-8 w-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x h-5 w-5 text-white"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>
        </button>

        <div className="flex items-center gap-3 pr-8">
          <div class="h-11 w-11 rounded-xl bg-white/10 flex items-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-search h-5 w-5 text-white"><circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.3-4.3"></path></svg><div></div></div>

          <h3 className="text-base font-semibold text-white">
            How It Works
          </h3>
        </div>
      </div>

      <div className="px-5 py-5 overflow-y-auto max-h-[60vh]">
        <ul className="space-y-3">
          {[
            "Choose a destination + theme (skills / networking / experiences)",
            "Travel with a curated group of growth-minded travellers",
            "Learn through workshops, activities & real-life experiences",
            "Return with skills, connections & clarity",
          ].map((text, i) => (
            <li key={i} className="flex items-start gap-3">
              <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center mt-0.5">
                <span className="text-xs font-semibold text-slate-600">
                  {i + 1}
                </span>
              </div>
              <p className="text-slate-600 text-sm leading-relaxed">
                {text}
              </p>
            </li>
          ))}
        </ul>

        <div className="mt-5 p-4 rounded-xl bg-slate-50 border border-slate-100">
          <p className="text-slate-800 font-medium text-center text-sm">
            No classrooms. No pressure. Just practical learning.
          </p>
        </div>
      </div>
    </div>

    {/* ================= DESKTOP MODAL ================= */}
    <div className="hidden md:block bg-white rounded-2xl max-w-lg w-full max-h-[85vh] overflow-hidden shadow-2xl border border-slate-200 mx-4 animate-in fade-in zoom-in-95 duration-200">

      <div className="bg-slate-900 px-6 py-5 relative">
        <button
          onClick={() => setActiveModal(null)}
          className="absolute top-4 right-4 h-8 w-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
        >
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x h-5 w-5 text-white"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>        </button>

        <div className="flex items-center gap-3">
          <div class="h-11 w-11 rounded-xl bg-white/10 flex items-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-search h-5 w-5 text-white"><circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.3-4.3"></path></svg><div></div></div>
          <h3 className="text-lg font-semibold text-white">
            How It Works
          </h3>
        </div>
      </div>

      <div className="px-6 py-6">
        <ul className="space-y-4">
          {[
            "Choose a destination + theme (skills / networking / experiences)",
            "Travel with a curated group of growth-minded travellers",
            "Learn through workshops, activities & real-life experiences",
            "Return with skills, connections & clarity",
          ].map((text, i) => (
            <li key={i} className="flex items-start gap-3">
              <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center mt-0.5">
                <span className="text-xs font-semibold text-slate-600">
                  {i + 1}
                </span>
              </div>
              <p className="text-slate-600 leading-relaxed">
                {text}
              </p>
            </li>
          ))}
        </ul>

        <div className="mt-6 p-4 rounded-xl bg-slate-50 border border-slate-100">
          <p className="text-slate-800 font-medium text-center text-sm">
            No classrooms. No pressure. Just practical learning.
          </p>
        </div>
      </div>
    </div>
  </div>
)}

{activeModal === "who" && (
  <div className="fixed inset-0 z-[100] flex items-end md:items-center justify-center bg-black/50 backdrop-blur-sm">
  <div className="md:hidden bg-white rounded-t-2xl w-full max-h-[85vh] overflow-hidden shadow-2xl animate-in slide-in-from-bottom duration-300">
    <div className="flex justify-center pt-3 pb-2">
      <div className="w-10 h-1 bg-slate-300 rounded-full" />
    </div>
    <div className="bg-slate-900 px-5 py-4 relative mx-4 rounded-xl">
      <button
        type="button" onClick={() => setActiveModal(null)}
        className="absolute top-3 right-3 h-8 w-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-x h-5 w-5 text-white"
        >
          <path d="M18 6 6 18" />
          <path d="m6 6 12 12" />
        </svg>
      </button>
      <div className="flex items-center gap-3 pr-8">
        <div className="h-10 w-10 rounded-xl bg-white/10 flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-target h-5 w-5 text-white"
          >
            <circle cx={12} cy={12} r={10} />
            <circle cx={12} cy={12} r={6} />
            <circle cx={12} cy={12} r={2} />
          </svg>
        </div>
        <h3 className="text-base font-semibold text-white">Who Is This For?</h3>
      </div>
    </div>
    <div className="px-5 py-5 overflow-y-auto max-h-[60vh]">
      <ul className="space-y-3">
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">1</span>
          </div>
          <p className="text-slate-600 leading-relaxed text-sm">
            Curious travellers who want more than sightseeing
          </p>
        </li>
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">2</span>
          </div>
          <p className="text-slate-600 leading-relaxed text-sm">
            Professionals looking to upgrade skills while travelling
          </p>
        </li>
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">3</span>
          </div>
          <p className="text-slate-600 leading-relaxed text-sm">
            Creators, entrepreneurs &amp; freelancers
          </p>
        </li>
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">4</span>
          </div>
          <p className="text-slate-600 leading-relaxed text-sm">
            Anyone who believes travel should add value to life
          </p>
        </li>
      </ul>
      <div className="mt-5 p-4 rounded-xl bg-slate-50 border border-slate-100">
        <p className="text-slate-800 font-medium text-center text-sm">
          If you love growth, you'll fit right in.
        </p>
      </div>
    </div>
  </div>
  <div className="hidden md:block bg-white rounded-2xl max-w-lg w-full max-h-[85vh] overflow-hidden shadow-2xl border border-slate-200 mx-4 animate-in fade-in zoom-in-95 duration-200">
    <div className="bg-slate-900 px-6 py-5 relative">
      <button
        type="button" onClick={() => setActiveModal(null)}
        className="absolute top-4 right-4 h-8 w-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-x h-5 w-5 text-white"
        >
          <path d="M18 6 6 18" />
          <path d="m6 6 12 12" />
        </svg>
      </button>
      <div className="flex items-center gap-3">
        <div className="h-11 w-11 rounded-xl bg-white/10 flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-target h-5 w-5 text-white"
          >
            <circle cx={12} cy={12} r={10} />
            <circle cx={12} cy={12} r={6} />
            <circle cx={12} cy={12} r={2} />
          </svg>
        </div>
        <h3 className="text-lg font-semibold text-white">Who Is This For?</h3>
      </div>
    </div>
    <div className="px-6 py-6">
      <ul className="space-y-4">
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">1</span>
          </div>
          <p className="text-slate-600 leading-relaxed">
            Curious travellers who want more than sightseeing
          </p>
        </li>
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">2</span>
          </div>
          <p className="text-slate-600 leading-relaxed">
            Professionals looking to upgrade skills while travelling
          </p>
        </li>
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">3</span>
          </div>
          <p className="text-slate-600 leading-relaxed">
            Creators, entrepreneurs &amp; freelancers
          </p>
        </li>
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">4</span>
          </div>
          <p className="text-slate-600 leading-relaxed">
            Anyone who believes travel should add value to life
          </p>
        </li>
      </ul>
      <div className="mt-6 p-4 rounded-xl bg-slate-50 border border-slate-100">
        <p className="text-slate-800 font-medium text-center text-sm">
          If you love growth, you'll fit right in.
        </p>
      </div>
    </div>
  </div>
</div>
)}

{activeModal === "learn" && (
<div className="fixed inset-0 z-[100] flex items-end md:items-center justify-center bg-black/50 backdrop-blur-sm">
  <div className="md:hidden bg-white rounded-t-2xl w-full max-h-[85vh] overflow-hidden shadow-2xl animate-in slide-in-from-bottom duration-300">
    <div className="flex justify-center pt-3 pb-2">
      <div className="w-10 h-1 bg-slate-300 rounded-full" />
    </div>
    <div className="bg-slate-900 px-5 py-4 relative mx-4 rounded-xl">
      <button
        type="button" onClick={() => setActiveModal(null)}
        className="absolute top-3 right-3 h-8 w-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-x h-5 w-5 text-white"
        >
          <path d="M18 6 6 18" />
          <path d="m6 6 12 12" />
        </svg>
      </button>
      <div className="flex items-center gap-3 pr-8">
        <div className="h-10 w-10 rounded-xl bg-white/10 flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-lightbulb h-5 w-5 text-white"
          >
            <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
            <path d="M9 18h6" />
            <path d="M10 22h4" />
          </svg>
        </div>
        <h3 className="text-base font-semibold text-white">
          What Will You Learn?
        </h3>
      </div>
    </div>
    <div className="px-5 py-5 overflow-y-auto max-h-[60vh]">
      <ul className="space-y-3">
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">1</span>
          </div>
          <p className="text-slate-600 leading-relaxed text-sm">
            Practical skills (varies by trip theme)
          </p>
        </li>
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">2</span>
          </div>
          <p className="text-slate-600 leading-relaxed text-sm">
            Communication &amp; confidence through group experiences
          </p>
        </li>
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">3</span>
          </div>
          <p className="text-slate-600 leading-relaxed text-sm">
            Industry insights from mentors &amp; peers
          </p>
        </li>
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">4</span>
          </div>
          <p className="text-slate-600 leading-relaxed text-sm">
            Real-world learning you can apply immediately
          </p>
        </li>
      </ul>
      <div className="mt-5 p-4 rounded-xl bg-slate-50 border border-slate-100">
        <p className="text-slate-800 font-medium text-center text-sm">
          Skills that stay long after the trip ends.
        </p>
      </div>
    </div>
  </div>
  <div className="hidden md:block bg-white rounded-2xl max-w-lg w-full max-h-[85vh] overflow-hidden shadow-2xl border border-slate-200 mx-4 animate-in fade-in zoom-in-95 duration-200">
    <div className="bg-slate-900 px-6 py-5 relative">
      <button
        type="button" onClick={() => setActiveModal(null)}
        className="absolute top-4 right-4 h-8 w-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-x h-5 w-5 text-white"
        >
          <path d="M18 6 6 18" />
          <path d="m6 6 12 12" />
        </svg>
      </button>
      <div className="flex items-center gap-3">
        <div className="h-11 w-11 rounded-xl bg-white/10 flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-lightbulb h-5 w-5 text-white"
          >
            <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
            <path d="M9 18h6" />
            <path d="M10 22h4" />
          </svg>
        </div>
        <h3 className="text-lg font-semibold text-white">
          What Will You Learn?
        </h3>
      </div>
    </div>
    <div className="px-6 py-6">
      <ul className="space-y-4">
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">1</span>
          </div>
          <p className="text-slate-600 leading-relaxed">
            Practical skills (varies by trip theme)
          </p>
        </li>
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">2</span>
          </div>
          <p className="text-slate-600 leading-relaxed">
            Communication &amp; confidence through group experiences
          </p>
        </li>
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">3</span>
          </div>
          <p className="text-slate-600 leading-relaxed">
            Industry insights from mentors &amp; peers
          </p>
        </li>
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">4</span>
          </div>
          <p className="text-slate-600 leading-relaxed">
            Real-world learning you can apply immediately
          </p>
        </li>
      </ul>
      <div className="mt-6 p-4 rounded-xl bg-slate-50 border border-slate-100">
        <p className="text-slate-800 font-medium text-center text-sm">
          Skills that stay long after the trip ends.
        </p>
      </div>
    </div>
  </div>
</div>
)}

{activeModal === "meet" && (
<div className="fixed inset-0 z-[100] flex items-end md:items-center justify-center bg-black/50 backdrop-blur-sm">
  <div className="md:hidden bg-white rounded-t-2xl w-full max-h-[85vh] overflow-hidden shadow-2xl animate-in slide-in-from-bottom duration-300">
    <div className="flex justify-center pt-3 pb-2">
      <div className="w-10 h-1 bg-slate-300 rounded-full" />
    </div>
    <div className="bg-slate-900 px-5 py-4 relative mx-4 rounded-xl">
      <button
        type="button" onClick={() => setActiveModal(null)}
        className="absolute top-3 right-3 h-8 w-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-x h-5 w-5 text-white"
        >
          <path d="M18 6 6 18" />
          <path d="m6 6 12 12" />
        </svg>
      </button>
      <div className="flex items-center gap-3 pr-8">
        <div className="h-10 w-10 rounded-xl bg-white/10 flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-users h-5 w-5 text-white"
          >
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
            <circle cx={9} cy={7} r={4} />
            <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
          </svg>
        </div>
        <h3 className="text-base font-semibold text-white">Who You'll Meet</h3>
      </div>
    </div>
    <div className="px-5 py-5 overflow-y-auto max-h-[60vh]">
      <ul className="space-y-3">
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">1</span>
          </div>
          <p className="text-slate-600 leading-relaxed text-sm">
            Like-minded travellers &amp; learners
          </p>
        </li>
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">2</span>
          </div>
          <p className="text-slate-600 leading-relaxed text-sm">
            Creators, professionals &amp; founders
          </p>
        </li>
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">3</span>
          </div>
          <p className="text-slate-600 leading-relaxed text-sm">
            Mentors, facilitators &amp; community leaders
          </p>
        </li>
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">4</span>
          </div>
          <p className="text-slate-600 leading-relaxed text-sm">
            Future collaborators &amp; lifelong friends
          </p>
        </li>
      </ul>
      <div className="mt-5 p-4 rounded-xl bg-slate-50 border border-slate-100">
        <p className="text-slate-800 font-medium text-center text-sm">
          Your network grows with every journey.
        </p>
      </div>
    </div>
  </div>
  <div className="hidden md:block bg-white rounded-2xl max-w-lg w-full max-h-[85vh] overflow-hidden shadow-2xl border border-slate-200 mx-4 animate-in fade-in zoom-in-95 duration-200">
    <div className="bg-slate-900 px-6 py-5 relative">
      <button
        type="button" onClick={() => setActiveModal(null)}
        className="absolute top-4 right-4 h-8 w-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-x h-5 w-5 text-white"
        >
          <path d="M18 6 6 18" />
          <path d="m6 6 12 12" />
        </svg>
      </button>
      <div className="flex items-center gap-3">
        <div className="h-11 w-11 rounded-xl bg-white/10 flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-users h-5 w-5 text-white"
          >
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
            <circle cx={9} cy={7} r={4} />
            <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
          </svg>
        </div>
        <h3 className="text-lg font-semibold text-white">Who You'll Meet</h3>
      </div>
    </div>
    <div className="px-6 py-6">
      <ul className="space-y-4">
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">1</span>
          </div>
          <p className="text-slate-600 leading-relaxed">
            Like-minded travellers &amp; learners
          </p>
        </li>
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">2</span>
          </div>
          <p className="text-slate-600 leading-relaxed">
            Creators, professionals &amp; founders
          </p>
        </li>
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">3</span>
          </div>
          <p className="text-slate-600 leading-relaxed">
            Mentors, facilitators &amp; community leaders
          </p>
        </li>
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">4</span>
          </div>
          <p className="text-slate-600 leading-relaxed">
            Future collaborators &amp; lifelong friends
          </p>
        </li>
      </ul>
      <div className="mt-6 p-4 rounded-xl bg-slate-50 border border-slate-100">
        <p className="text-slate-800 font-medium text-center text-sm">
          Your network grows with every journey.
        </p>
      </div>
    </div>
  </div>
</div>
)}

{activeModal === "different" && (
<div className="fixed inset-0 z-[100] flex items-end md:items-center justify-center bg-black/50 backdrop-blur-sm">
  <div className="md:hidden bg-white rounded-t-2xl w-full max-h-[85vh] overflow-hidden shadow-2xl animate-in slide-in-from-bottom duration-300">
    <div className="flex justify-center pt-3 pb-2">
      <div className="w-10 h-1 bg-slate-300 rounded-full" />
    </div>
    <div className="bg-slate-900 px-5 py-4 relative mx-4 rounded-xl">
      <button
        type="button" onClick={() => setActiveModal(null)}
        className="absolute top-3 right-3 h-8 w-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-x h-5 w-5 text-white"
        >
          <path d="M18 6 6 18" />
          <path d="m6 6 12 12" />
        </svg>
      </button>
      <div className="flex items-center gap-3 pr-8">
        <div className="h-10 w-10 rounded-xl bg-white/10 flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-globe h-5 w-5 text-white"
          >
            <circle cx={12} cy={12} r={10} />
            <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
            <path d="M2 12h20" />
          </svg>
        </div>
        <h3 className="text-base font-semibold text-white">
          What Makes This Different?
        </h3>
      </div>
    </div>
    <div className="px-5 py-5 overflow-y-auto max-h-[60vh]">
      <ul className="space-y-3">
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">1</span>
          </div>
          <p className="text-slate-600 leading-relaxed text-sm">
            Travel + learning + networking in one experience
          </p>
        </li>
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">2</span>
          </div>
          <p className="text-slate-600 leading-relaxed text-sm">
            Curated groups (quality over quantity)
          </p>
        </li>
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">3</span>
          </div>
          <p className="text-slate-600 leading-relaxed text-sm">
            Community-first, not tourist-first
          </p>
        </li>
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">4</span>
          </div>
          <p className="text-slate-600 leading-relaxed text-sm">
            Designed for growth, not just relaxation
          </p>
        </li>
      </ul>
      <div className="mt-5 p-4 rounded-xl bg-slate-50 border border-slate-100">
        <p className="text-slate-800 font-medium text-center text-sm">
          This is travel with intent.
        </p>
      </div>
    </div>
  </div>
  <div className="hidden md:block bg-white rounded-2xl max-w-lg w-full max-h-[85vh] overflow-hidden shadow-2xl border border-slate-200 mx-4 animate-in fade-in zoom-in-95 duration-200">
    <div className="bg-slate-900 px-6 py-5 relative">
      <button
        type="button" onClick={() => setActiveModal(null)}
        className="absolute top-4 right-4 h-8 w-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-x h-5 w-5 text-white"
        >
          <path d="M18 6 6 18" />
          <path d="m6 6 12 12" />
        </svg>
      </button>
      <div className="flex items-center gap-3">
        <div className="h-11 w-11 rounded-xl bg-white/10 flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-globe h-5 w-5 text-white"
          >
            <circle cx={12} cy={12} r={10} />
            <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
            <path d="M2 12h20" />
          </svg>
        </div>
        <h3 className="text-lg font-semibold text-white">
          What Makes This Different?
        </h3>
      </div>
    </div>
    <div className="px-6 py-6">
      <ul className="space-y-4">
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">1</span>
          </div>
          <p className="text-slate-600 leading-relaxed">
            Travel + learning + networking in one experience
          </p>
        </li>
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">2</span>
          </div>
          <p className="text-slate-600 leading-relaxed">
            Curated groups (quality over quantity)
          </p>
        </li>
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">3</span>
          </div>
          <p className="text-slate-600 leading-relaxed">
            Community-first, not tourist-first
          </p>
        </li>
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">4</span>
          </div>
          <p className="text-slate-600 leading-relaxed">
            Designed for growth, not just relaxation
          </p>
        </li>
      </ul>
      <div className="mt-6 p-4 rounded-xl bg-slate-50 border border-slate-100">
        <p className="text-slate-800 font-medium text-center text-sm">
          This is travel with intent.
        </p>
      </div>
    </div>
  </div>
</div>

)}

{activeModal === "take" && (

<div className="fixed inset-0 z-[100] flex items-end md:items-center justify-center bg-black/50 backdrop-blur-sm">
  <div className="md:hidden bg-white rounded-t-2xl w-full max-h-[85vh] overflow-hidden shadow-2xl animate-in slide-in-from-bottom duration-300">
    <div className="flex justify-center pt-3 pb-2">
      <div className="w-10 h-1 bg-slate-300 rounded-full" />
    </div>
    <div className="bg-slate-900 px-5 py-4 relative mx-4 rounded-xl">
      <button
        type="button" onClick={() => setActiveModal(null)}
        className="absolute top-3 right-3 h-8 w-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-x h-5 w-5 text-white"
        >
          <path d="M18 6 6 18" />
          <path d="m6 6 12 12" />
        </svg>
      </button>
      <div className="flex items-center gap-3 pr-8">
        <div className="h-10 w-10 rounded-xl bg-white/10 flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-rocket h-5 w-5 text-white"
          >
            <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
            <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
            <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" />
            <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
          </svg>
        </div>
        <h3 className="text-base font-semibold text-white">
          What You Take Back Home
        </h3>
      </div>
    </div>
    <div className="px-5 py-5 overflow-y-auto max-h-[60vh]">
      <ul className="space-y-3">
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">1</span>
          </div>
          <p className="text-slate-600 leading-relaxed text-sm">
            New skills &amp; fresh perspectives
          </p>
        </li>
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">2</span>
          </div>
          <p className="text-slate-600 leading-relaxed text-sm">
            Strong personal and professional connections
          </p>
        </li>
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">3</span>
          </div>
          <p className="text-slate-600 leading-relaxed text-sm">
            Confidence, inspiration &amp; momentum
          </p>
        </li>
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">4</span>
          </div>
          <p className="text-slate-600 leading-relaxed text-sm">
            Stories that changed how you think
          </p>
        </li>
      </ul>
      <div className="mt-5 p-4 rounded-xl bg-slate-50 border border-slate-100">
        <p className="text-slate-800 font-medium text-center text-sm">
          Return home transformed.
        </p>
      </div>
    </div>
  </div>
  <div className="hidden md:block bg-white rounded-2xl max-w-lg w-full max-h-[85vh] overflow-hidden shadow-2xl border border-slate-200 mx-4 animate-in fade-in zoom-in-95 duration-200">
    <div className="bg-slate-900 px-6 py-5 relative">
      <button
        type="button" onClick={() => setActiveModal(null)}
        className="absolute top-4 right-4 h-8 w-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-x h-5 w-5 text-white"
        >
          <path d="M18 6 6 18" />
          <path d="m6 6 12 12" />
        </svg>
      </button>
      <div className="flex items-center gap-3">
        <div className="h-11 w-11 rounded-xl bg-white/10 flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-rocket h-5 w-5 text-white"
          >
            <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
            <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
            <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" />
            <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
          </svg>
        </div>
        <h3 className="text-lg font-semibold text-white">
          What You Take Back Home
        </h3>
      </div>
    </div>
    <div className="px-6 py-6">
      <ul className="space-y-4">
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">1</span>
          </div>
          <p className="text-slate-600 leading-relaxed">
            New skills &amp; fresh perspectives
          </p>
        </li>
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">2</span>
          </div>
          <p className="text-slate-600 leading-relaxed">
            Strong personal and professional connections
          </p>
        </li>
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">3</span>
          </div>
          <p className="text-slate-600 leading-relaxed">
            Confidence, inspiration &amp; momentum
          </p>
        </li>
        <li className="flex items-start gap-3">
          <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-xs font-semibold text-slate-600">4</span>
          </div>
          <p className="text-slate-600 leading-relaxed">
            Stories that changed how you think
          </p>
        </li>
      </ul>
      <div className="mt-6 p-4 rounded-xl bg-slate-50 border border-slate-100">
        <p className="text-slate-800 font-medium text-center text-sm">
          Return home transformed.
        </p>
      </div>
    </div>
  </div>
</div>

)}
      <Footer />
    </>
  );
};


export default ExperienceTrips;


